import { Noto_Sans_TC } from "next/font/google";
import Head from "next/head";

import useRetailShop from "../../hooks/useRetailShop";
import PosHeader from "./posHeader.comp";
import PosNav from "./posNav.comp";
import useBarcodeScanner from "../../hooks/useBarcodeScanner";

interface PosLayoutProps {
  title: string;
  children: React.ReactNode;
  showback?: boolean;
  noPadding?: boolean;
}

const notoSansTC = Noto_Sans_TC({ weight: ["100","200","300","400", "500", "600", "700", "800", "900"], subsets: ["latin"] });


export default function PosLayout({ children, title, showback, noPadding }: PosLayoutProps) {
  useBarcodeScanner();
  const retail = useRetailShop();

  const titleString = `${title} - ${retail?.name} - HER POS`;

  return (
    <>
      <Head>
        <title>{titleString}</title>
      </Head>

      <div
        className={`text-black h-screen dark:text-black bg-her-lightgray dark:bg-her-backblue overflow-y-hidden pt-[72px] 
          ${notoSansTC.className}
          `}
      >
        <PosHeader showback={showback} />

        <main className="flex h-[calc(100dvh-72px)]">
          <PosNav className="h-full hidden lg:block" />

          <div className={`space-y-4 overflow-y-scroll  ${noPadding ? "p-0" : "p-3 "} w-full`}>{children}</div>
        </main>
      </div>
    </>
  );
}
